import { useState } from 'react';
import { faqs } from '@/mocks/home';

export default function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return (
    <section id="faq" className="bg-background-50 scroll-mt-20">
      <div className="max-w-3xl mx-auto px-4 md:px-6 py-14 md:py-24">
        <h2 className="font-heading font-bold text-3xl md:text-4xl text-foreground-950 mb-8 md:mb-12 text-center">Questions, answered</h2>
        <div className="flex flex-col gap-3">
          {faqs.map((f, i) => {
            const isOpen = open === i;
            return (
              <div key={f.q} className={`rounded-2xl border transition-colors ${isOpen ? 'border-accent-200 bg-accent-50' : 'border-background-200 bg-background-50 shadow-pink'}`}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer">
                  <span className="font-heading font-bold text-base md:text-lg text-foreground-950">{f.q}</span>
                  <span className={`w-8 h-8 shrink-0 rounded-full flex items-center justify-center text-lg ${isOpen ? 'grad-cta text-background-50' : 'bg-background-100 text-primary-600'}`}>
                    <i className={isOpen ? 'ri-subtract-line' : 'ri-add-line'}></i>
                  </span>
                </button>
                {isOpen && <p className="px-5 pb-5 text-sm md:text-base text-foreground-700 leading-relaxed">{f.a}</p>}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}